import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const TrocarSenhaDialog = ({ open, onOpenChange, obrigatorio = false }) => {
  const { refreshUser, logout } = useAuth();
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [conf, setConf] = useState("");
  const [erro, setErro] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErro("");
    if (nova.length < 6) return setErro("A nova senha deve ter no mínimo 6 caracteres.");
    if (nova !== conf) return setErro("A confirmação não confere com a nova senha.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { senha_atual: atual, nova_senha: nova });
      toast.success("Senha definida com sucesso");
      setAtual(""); setNova(""); setConf("");
      await refreshUser();
      onOpenChange?.(false);
    } catch (err) {
      setErro(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={obrigatorio ? undefined : onOpenChange}>
      <DialogContent
        className="max-w-md"
        data-testid="trocar-senha-dialog"
        onEscapeKeyDown={(e) => obrigatorio && e.preventDefault()}
        onPointerDownOutside={(e) => obrigatorio && e.preventDefault()}
        onInteractOutside={(e) => obrigatorio && e.preventDefault()}
        hideClose={obrigatorio || undefined}
      >
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 font-display">
              <KeyRound className="h-5 w-5 text-primary" />
              {obrigatorio ? "Crie sua senha de acesso" : "Alterar minha senha"}
            </DialogTitle>
            <DialogDescription className="text-sm">
              {obrigatorio
                ? "Sua senha foi definida pelo administrador. Para continuar, crie uma senha pessoal."
                : "Informe a senha atual e a nova senha."}
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 mt-5">
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-500">
                {obrigatorio ? "Senha recebida do administrador" : "Senha atual"}
              </Label>
              <Input
                type="password"
                value={atual}
                onChange={(e) => setAtual(e.target.value)}
                data-testid="senha-atual-input"
                className="mt-1.5 h-11"
                autoFocus
                required
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-500">Nova senha</Label>
              <Input
                type="password"
                value={nova}
                onChange={(e) => setNova(e.target.value)}
                data-testid="nova-senha-input"
                className="mt-1.5 h-11"
                required
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-500">Confirmar nova senha</Label>
              <Input
                type="password"
                value={conf}
                onChange={(e) => setConf(e.target.value)}
                data-testid="confirmar-senha-input"
                className="mt-1.5 h-11"
                required
              />
            </div>
          </div>

          {erro && (
            <p data-testid="trocar-senha-erro" className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2 rounded-md">
              {erro}
            </p>
          )}

          <div className="flex items-center gap-2 mt-6">
            <Button type="submit" disabled={busy} data-testid="salvar-senha-btn" className="bg-primary hover:bg-[#003366] h-11 flex-1">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar senha"}
            </Button>
            {obrigatorio ? (
              <Button type="button" variant="outline" onClick={logout} data-testid="sair-troca-senha-btn" className="h-11">
                Sair
              </Button>
            ) : (
              <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="cancelar-senha-btn" className="h-11">
                Cancelar
              </Button>
            )}
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
